import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Mention, MentionsInput} from "react-mentions";
import Button from "@components/common/Button";
import useSWR from "swr";
import {useStore} from "../../app/store";
import axios from "axios";
import {ModalBody} from "./Modal";
import {observer} from "mobx-react";
import {toast} from "react-toastify";

const CommentWriteModal = ({handleCloseModal, modalDepth, modalMutate}) => {
    let postCommentChk = false
    const [commentValue, setCommentValue] = useState('');
    const [btnActive, isBtnActive] = useState(false)
    const [users, setUsers] = useState([{id: '', display: ''}]);
    const {data: nameList, isLoading} = useSWR('/users/nameList');
    const {appEditorStore} = useStore();
    useEffect(() => {
        const setNewAry = [];
        !isLoading && nameList.data.userNames.ALIVE.map((e, i) => (
            setNewAry.push({id: e, display: `@${e}`})
        ))
        setUsers(setNewAry)
    }, [nameList]);


    const onChangeComment = (e) => {
        setCommentValue(e.target.value);
        appEditorStore.commentWriteValue = e.target.value;
        e.target.value.replace(/\s/g, "") !== '' ? isBtnActive(true) : isBtnActive(false);
    }
    const submitWriteComment = async () => {

        console.log()
        if (appEditorStore.commentWriteValue === '') {
            return;
        }
        if (!postCommentChk) {
            let commentData = {
                pageId: appEditorStore.pageInfo.id,
                selector: appEditorStore.boardCommentMap.selector,
                content: appEditorStore.commentWriteValue
            };

            try {
                await axios.post("/comment", commentData);
                await modalMutate();
                appEditorStore.commentWriteValue = '';
                handleCloseModal(modalDepth);
                postCommentChk = true;
                toast("댓글이 작성되었습니다.", {autoClose: 1000});
            } catch (e) {
                console.log(`댓글 저장에 실패하였습니다.\n${e.message}`);
            }


        }

    }
    return (
        <ModalBody id={"CommentWriteEditorModal"}>
            <EditCommentWrap className={"modal-container"}>
                <CommentArea>
                    <MentionsInput
                        placeholder="내용을 입력해 주세요."
                        spellCheck='false'
                        value={commentValue}
                        onChange={onChangeComment}
                        style={mentionsInputStyle}
                        a11ySuggestionsListLabel={'Suggested mentions'}
                        className={'comment'}
                    >
                        <Mention
                            markup="(@/__id__)"
                            // displayTransform={(url) => `@${url}`}
                            trigger="@"
                            displayTransform={(username) => `@${username}`}
                            // markup="@__display__/__id__/"
                            data={users}
                            // regex={/@(\S+)/}
                            style={mentionStyle}
                            appendSpaceOnAdd
                            // renderSuggestion={(suggestion, search, highlightedDisplay) => (
                            //     <div className="user">{highlightedDisplay}</div>
                            // )}
                        />
                    </MentionsInput>
                </CommentArea>

                <div className={"comment-submit" + (btnActive ? ' active ' : '  ')}>
                    <Button
                        type={"fill"}
                        size={"s"}
                        text={"등록"}
                        onClickFunc={submitWriteComment}
                    ></Button>
                </div>
            </EditCommentWrap>
        </ModalBody>
    );
};

const EditCommentWrap = styled.article`
    background-color: #fff;
    padding: 32px;

    .comment-submit {
        width: 100%;
        margin-top: 20px;
        display: flex;
        justify-content: center;

        button {
            width: 100%;
            border: none;
            background-color: #262626;
            pointer-events: none;
            height: 40px;
        }

        &.active {
            button {
                cursor: pointer;
                pointer-events: auto;
                background-color: #C86733;
            }
        }
    }
`;

const CommentArea = styled.div`
    width: 100%;
    border: 1px solid #dfdfdf;
    border-radius: 4px;
    box-sizing: border-box;

    > div > div:nth-of-type(2) {
        overflow: hidden;
        border-radius: 4px;
        border: 1px solid #dfdfdf;
    }

    & .user {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-break: break-all;
    }


`;
export const mentionStyle = {
    position: 'relative',
    zIndex: 1,
    color: '#0D99FF',
    textShadow: '1px 1px 1px white, 1px -1px 1px white, -1px 1px 1px white, -1px -1px 1px white',
    pointerEvents: 'none',
}
export const mentionsInputStyle = {
    control: {
        fontSize: 13,
        minHeight: 160,
        fontFamily: 'monospace',
        fontWeight: '400',
        backgroundColor: '#fff',
    },
    '&multiLine': {
        control: {
            fontSize: 13,
            minHeight: 160,
            fontFamily: 'monospace',
            fontWeight: '400',
            backgroundColor: '#fff',
            lineHeight: '18px',
            borderRadius: '4px',
        },
        highlighter: {
            color: 'transparent',
            fontFamily: 'monospace',
            width: '100%',
            border: 'none',
            height: 160,
            padding: 16,
            overflow: 'hidden',
            position: 'relative',
            overflowWrap: 'break-word',
            boxSizing: 'border-box',
            textAlign: 'start',
            whiteSpace: 'pre-wrap',
            fontSize: 13,
            fontWeight: '400',
            lineHeight: '18px',
        },
        input: {
            top: 0,
            left: 0,
            width: '100%',
            border: 'none',
            bottom: 0,
            height: 160,
            resize: 'none',
            display: 'block',
            padding: 16,
            overflow: 'auto',
            position: 'absolute',
            fontSize: '13px',
            boxSizing: 'border-box',
            fontFamily: 'monospace',
            letterSpacing: 'inherit',
            backgroundColor: 'transparent',
            outline: 'none',
            fontWeight: '400',
            lineHeight: '18px',
            color: '#262626',
        },
    },
    suggestions: {
        list: {
            backgroundColor: 'white',
            width: 120,
            maxHeight: 72,
            overflowY: 'auto',
            overflowX: 'hidden',
        },
        item: {
            width: '100%',
            padding: '4px 8px',
            color: '#262626',
            fontSize: 12,
            fontWeight: 400,
            lineHeight: '16px',
            letterSpacing: -0.24,
            '&focused': {
                backgroundColor: '#C86733',
                color: '#fff',
            },

        },
    },
}

// export default CommentWriteModal;
export default observer(CommentWriteModal);
